import { render, staticRenderFns } from "./ResourceWidgets.vue?vue&type=template&id=1ca43d1f&scoped=true&"
import script from "./ResourceWidgets.vue?vue&type=script&lang=js&"
export * from "./ResourceWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca43d1f",
  null
  
)

export default component.exports